/**
 * Вход сотрудника платформы.
 *
 * Отдельный вход, а не роль в кабинете партнёра: токен кабинета не должен
 * открывать админку даже при ошибке в проверке роли.
 */
import { ApiError } from '@allswipes/client';
import { Button, Card, Field, Logo } from '@allswipes/ui';
import { useState } from 'react';

import { api } from '../api';
import { useAdmin } from '../session';

export function LoginScreen() {
  const { refresh } = useAdmin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.adminLogin(email, password);
      await refresh();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось войти');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <Card className="box raised">
        <div style={{ marginBottom: 14 }}>
          <Logo height={20} />
          <div className="faint" style={{ fontSize: 11.5, marginTop: 6 }}>
            админка платформы
          </div>
        </div>
        <p className="sub" style={{ marginBottom: 16 }}>
          Модерация, бренды, главная полоса и доступы. Каждое действие уходит в журнал с твоей
          почтой.
        </p>

        <form onSubmit={submit}>
          <Field label="Почта">
            <input
              className="input"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Field label="Пароль" error={error ?? undefined}>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          <Button variant="pri" block type="submit" disabled={busy || !email || !password}>
            Войти
          </Button>
        </form>

        <p className="faint" style={{ fontSize: 11.5, marginTop: 14 }}>
          Доступ выдаёт суперадмин. Публичной регистрации здесь нет и не будет.
        </p>
      </Card>
    </div>
  );
}
